// Shopify analytics cookies.
//
// Reading parses `document.cookie` directly (the same simple regex approach
// hydrogen-react's own cookie reader uses internally) — we don't depend on
// hydrogen-react's `getShopifyCookies`, which is deprecated. Writing the
// cookies is straightforward enough to do in-house — `useShopifyCookies` is a
// React hook we can't call here, but its underlying logic is just two
// `document.cookie` writes.

export const COOKIE_Y = '_shopify_y';
export const COOKIE_S = '_shopify_s';
export const LONG_TERM_SECONDS = 60 * 60 * 24 * 360; // ~1 year (matches hydrogen)
export const SHORT_TERM_SECONDS = 60 * 30; // 30 minutes (matches hydrogen)

export function writeCookie(name: string, value: string, maxAgeSeconds: number, domain: string) {
	const parts = [
		`${name}=${encodeURIComponent(value)}`,
		`Max-Age=${maxAgeSeconds | 0}`,
		'Path=/',
		'SameSite=Lax',
	];
	if (domain) parts.push(`Domain=${domain}`);
	if (typeof location !== 'undefined' && location.protocol === 'https:') {
		parts.push('Secure');
	}
	document.cookie = parts.join('; ');
}

/**
 * Resolve the cookie domain. For non-localhost hosts we prefix with a leading
 * dot so subdomains (checkout, accounts) share the cookie — same behaviour
 * `useShopifyCookies` uses.
 */
export function resolveCookieDomain(configuredDomain?: string): string {
	const host = (configuredDomain || (typeof location !== 'undefined' ? location.hostname : '')) || '';
	if (!host || /^localhost$/i.test(host)) return '';
	// IP literals can't have a leading-dot domain
	if (/^\d/.test(host)) return '';
	return host.charAt(0) === '.' ? host : `.${host}`;
}

export interface CookieTokens {
	unique: string;
	visit: string;
}

function readCookie(name: string): string {
	if (typeof document === 'undefined') return '';
	const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
	return match ? decodeURIComponent(match[1]) : '';
}

export function readShopifyCookies(): CookieTokens {
	return { unique: readCookie(COOKIE_Y), visit: readCookie(COOKIE_S) };
}
